import { MetaInfo } from "@/components/meta-info"
import { SettingsHeader } from "../settings-header"
import { EmailInboxSettingsContent } from "./email-inbox-settings-content"

export const EmailsInboxSettingsPage = () => {
	return (
		<>
			<MetaInfo title="Email Inbox" />

			<SettingsHeader
				title="Shared email"
				subtitle="Reply to customers and follow up on requests."
				docsArticle="e1e61420-452d-4bb7-82a4-ab843f79c739"
			/>
			<EmailInboxSettingsContent />
		</>
	)
}
